import { createContext } from 'react';

export type DeleteUserCtx = {
  showDeleteUserSuccessAlert: boolean;
  showDeleteUserErrorAlert: boolean;
  showDeleteUserConfirmationAlert: boolean;
  DeleteUserError: string;
};

const DeleteUserContext = createContext<DeleteUserCtx>({
  showDeleteUserSuccessAlert: false,
  showDeleteUserErrorAlert: false,
  showDeleteUserConfirmationAlert: false,
  DeleteUserError: '',
});

export default DeleteUserContext;
